// extracted by mini-css-extract-plugin
export default {"start-timer-section":"startTimer_start-timer-section__lLgUU","opacity-animation":"startTimer_opacity-animation__HgrTI","time":"startTimer_time__DQzkb"};